module.exports = __webpack_public_path__ + "static/img/floor2-gdsc.f9caa7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dh-map/floor2-gdsc.png
// module id = YnwS
// module chunks = 1